<template>
    <el-submenu v-if="!item.hidden && checkAdmin(item)" :index="item.path">
        <template slot="title">
            <img :src="`${require('@/assets/images/home/'+item.meta.icon)}`" />
            <span>{{item.name}}</span>
        </template>
        <el-menu-item-group>
            <el-menu-item v-for="child in item.children" 
            :key="child.path" :index="child.path">{{child.meta.title}}</el-menu-item>
        </el-menu-item-group>
    </el-submenu>
</template>

<script>
export default {
    props:{
        item: {
            type: Object,
            required: true
        },
        basePath: {
            type: String,
            default: ''
        },
        isAdmin:{
            type:Boolean,
            default:false
        }
    },
    mounted() {
    },
    methods:{
        checkAdmin(item){
            let result = true
            if(!this.isAdmin){
                if(item.has == 'admin'){
                    result = false
                }
            }
            return result
        }
    }
}
</script>


// WEBPACK FOOTER //
// src/components/SidebarItem.vue